<div class="poll-message" *ngIf="body" (click)="$event.stopPropagation()">
  <!-- The title's left edge lines up with the hint icon below it, as in the mobile app. -->
  <div class="poll-title">{{body.title}}</div>

  <div class="poll-hint">
    <ng-container *ngIf="poll && poll.is_ended; else selectHint">
      <span class="hint-icon"><i class="fa fa-lock"></i></span>
      <span>{{'WEBCLIENT.CHATROOM.POLL.ENDED' | translate}}</span>
    </ng-container>

    <ng-template #selectHint>
      <!-- a doubled tick marks a poll that takes more than one answer -->
      <span class="hint-icon" *ngIf="!body.allow_multiple_choice">
        <i class="fa fa-check-circle"></i>
      </span>
      <span class="hint-icon multiple" *ngIf="body.allow_multiple_choice">
        <i class="fa fa-check-circle"></i>
        <i class="fa fa-check-circle"></i>
      </span>
      <span *ngIf="!body.allow_multiple_choice">{{'WEBCLIENT.CHATROOM.POLL.SELECT_ONE_HINT' | translate}}</span>
      <span *ngIf="body.allow_multiple_choice">{{'WEBCLIENT.CHATROOM.POLL.MULTIPLE_CHOICE_HINT' | translate}}</span>
    </ng-template>
  </div>

  <div class="poll-options" *ngIf="displayOptions.length > 0">
    <div class="poll-option" *ngFor="let option of displayOptions">
      <!-- tapping a selected option again retracts it -->
      <div class="option-row"
        [ngClass]="{'disabled': isVotingDisabled, 'clickable': !isVotingDisabled}"
        (click)="onOptionClick(option.option_id)">

        <div class="option-tick" [ngClass]="{'selected': isOptionSelected(option.option_id)}">
          <i class="fa fa-check" *ngIf="isOptionSelected(option.option_id)"></i>
        </div>

        <div class="option-text" [ngClass]="{'selected': isOptionSelected(option.option_id)}">{{option.content}}</div>

        <div class="option-voters" *ngIf="getOptionVoters(option).length > 0">
          <div class="voter-avatar default-contact-avatar"
            *ngFor="let voter of getOptionVoters(option)"
            [title]="getVoterName(voter)"
            [ngStyle]="{'background-image': getVoterAvatar(voter)}">
          </div>
        </div>

        <div class="option-count" *ngIf="poll && poll.should_display_result === 1">{{option.vote_count || 0}}</div>
      </div>

      <div class="option-result-bar" *ngIf="poll && poll.should_display_result === 1">
        <div class="option-result-bar-fill" [ngStyle]="{width: getOptionPercentage(option) + '%'}"></div>
      </div>
    </div>
  </div>

  <div class="poll-footer">
    <div class="poll-view-votes clickable" (click)="openPollDetail()">
      {{'WEBCLIENT.CHATROOM.POLL.VIEW_VOTES' | translate}}
    </div>
  </div>
</div>
